module.exports = __webpack_public_path__ + "img/kin7.480d9f8f.jpg";